import React from 'react'

const TONES = new Set(['blue', 'yellow', 'green', 'red', 'grey'])
// Older status helpers still return 'orange' for waiting and 'muted' for neutral.
const LEGACY_TONES = { orange: 'yellow', muted: 'grey', gray: 'grey' }

export function pillTone(tone) {
  const key = String(tone || '').toLowerCase()
  if (TONES.has(key)) return key
  return LEGACY_TONES[key] || 'grey'
}

export default function StatusPill({ tone = 'grey', as: Tag = 'span', className = '', children, ...rest }) {
  return (
    <Tag className={`status-pill status-pill--${pillTone(tone)}${className ? ` ${className}` : ''}`} {...rest}>
      <span className="status-pill__dot" aria-hidden="true" />
      {children}
    </Tag>
  )
}
